import PropTypes from 'prop-types';

import Grid from '@mui/material/Grid';

import { useEffect, useState } from 'react';
import MDBox from 'components/MDBox';
import PageLayout from 'components/LayoutContainers/PageLayout';
import Footer from 'pages/authentication/components/Footer';
import RayEffect from 'components/effects/RayEffect';

function BasicLayout({
  imageURL,
  title,
  justifyContent = 'center',
  alignItems = 'center',
  height = '100%',
  footerDisplayed = false,
  children
}) {
  const [bgImageFilename, setBgImageFilename] = useState(null);
  const [bgImage, setBgImage] = useState(null);

  useEffect(() => {
    fetch(imageURL).then((res) => {
      setBgImageFilename(res.headers?.get('content-disposition')?.split('"')[1]);
      res.blob().then((blob) => setBgImage(blob));
    });
  }, [imageURL]);

  return (
    <PageLayout title={title}>
      {bgImageFilename?.indexOf('_eRay') > 0 && <RayEffect />}

      <MDBox
        position="absolute"
        width="100%"
        minHeight="100vh"
        sx={{
          backgroundImage: bgImage && ` url(${URL.createObjectURL(bgImage)})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat'
        }}
      />

      <MDBox px={1} width="100%" height="100vh" mx="auto">
        <Grid
          container
          spacing={1}
          justifyContent={justifyContent}
          alignItems={alignItems}
          height="100%"
        >
          <Grid item xs={11} sm={9} md={5} lg={4} xl={3} height={height}>
            {children}
          </Grid>
        </Grid>
      </MDBox>
      {footerDisplayed && <Footer light />}
    </PageLayout>
  );
}

BasicLayout.propTypes = {
  imageURL: PropTypes.string.isRequired,
  title: PropTypes.string,
  justifyContent: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  alignItems: PropTypes.string,
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  footerDisplayed: PropTypes.bool,
  children: PropTypes.node.isRequired
};

export default BasicLayout;
